/**
 * Returns a promise that resolves when the props exist on the object
 * @param {Object} obj - the object to check
 * @param {string|string[]} props - the string representation of the props you're waiting for separated by .'s
 * @param {number} checkIntervalTime - how many ms to wait between checks
 * @param {number} timeoutTime - how long to wait for props before timing out
 * @returns {Promise} Promise object that resolves when the properties exist or rejects after the timeoutTime
 */

export default function waitForProps(
  obj,
  props,
  checkIntervalTime = 500,
  timeoutTime = 5000,
) {
  return new Promise((resolve, reject) => {
    const timeout = setTimeout(() => {
      clearTimeout(timeout)
      clearInterval(interval)
      reject()
    }, timeoutTime)
    const interval = setInterval(() => {
      let allPropsExist = true
      if (props.forEach) {
        props.forEach(propList => {
          checkPropList(propList)
        })
      } else {
        propList = props
        checkPropList(propList)
      }

      function checkPropList(propList) {
        let copyOfObj = Object.assign({}, obj)
        propList.split('.').forEach(prp => {
          if (copyOfObj[prp]) {
            copyOfObj = copyOfObj[prp]
          } else if (prp === '') {
            // do nothing
          } else {
            allPropsExist = false
          }
        })
      }

      if (allPropsExist) {
        clearTimeout(timeout)
        clearInterval(interval)
        resolve()
      }
    }, checkIntervalTime)
  })
}
